import { ModalMapKeys } from 'src/constants/modals';

export function getShouldReplace(modalName: ModalMapKeys = 'BONUS') {
  const openedModalName = localStorage.getItem('openedModalName');
  if (!openedModalName) return true;
  return openedModalName === modalName;
}
